import Header from '../Components/Header';
import Footer from '../Components/Footer';
import { Helmet } from 'react-helmet-async';

function Contact() {
  return (
    <div >
      <Helmet>
                    <title>Contact Aadikaash International – ISJS 2025 Exhibition Enquiries</title>
                    <meta
                      name="description"
                      content="Get in touch with Aadikaash International for ISJS 2025 exhibition participation, sponsorship, visitor registration, and media enquiries."
                    />
                    <meta
          name="keywords"
          content="contact Aadikaash, ISJS 2025 contact, jewellery show enquiries, exhibition sponsorship contact, gemstone trade show India"
        />
                  </Helmet>

      <Header />
    

      <div className='container main-contant contact-content'>
        <div className='inner-page-container'>
          <h1 className='page-title'>Contact Us</h1>
          <div className='row'>
            <div className='col-md-12'>
               <iframe src="https://aadikaash.com/backend/contact-us/" className='contact-iframe-box'></iframe>
            </div>
          </div>
        </div>

      </div>
      <Footer />
    </div>
  )
}

export default Contact;
